
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Caban.ts;
 * Path: ./src/environments/BaseEnvironments/Caban.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 28/11/24, 15:57;
 * Updated at: 28/11/24, 15:57;
 *
 */

import { CrmEnv } from '../Modules/CRM';
import { BadgeEnv } from "../Modules/Badge";
import { getModule, addModule } from '../Utility/ModuleUtility';
import { Environment as StoreCost } from './Store_Cost'

var AnnoCorrente = () => {
  var data = new Date();
  return data.getFullYear();
}

var Environment = () => {
  var env: any = {
    logoPath: 'assets/images/logoCaban.jpg',
  };
  env = addModule(BadgeEnv(), env);
  env = addModule(StoreCost(), env)
  env = addModule({
    Menu: [
      {
        module: "Personale",
        path: "/listautenti/personale",
        title: 'menu.PersonaleLabel',
        icon: "far fa-user",
        capacita: ["menu-persone"]
      },
      {
        module: "Clienti",
        path: "/listautenti/aziende",
        title: 'menu.clienti',
        icon: "mdi mdi-account-multiple",
        capacita: ["menu-clienti"]
      },
      {
        module: "Prodotti",
        title: "Taglie",
        path: "progetti/taglie",
        icon: "mdi mdi-tag",
        capacita: ["menu-taglie"]
      }
    ],
    theme: 'light',
    Personale: {
      initObj: [{ campo: 'infoAgg', tipo: 'object' }],
      Tabs: [
        //{id:'info', tipo: 'template', titolo: 'INFO', component: 'Edit' },
        {
          id: 'info',
          titolo: 'Anagrafica',
          tipo: 'sezioni',
          Azioni: [
            {
              nome: 'Salva',
              close: true,
              class: ' btn ',
              labelClass: 'ml-1 ',
              type: 'POST',
              restRoute: '/anagrafica/persone/update',
              icon: 'far fa-save text-success',
              placeholder: 'Salva',
              hideif: { fieldnotexist: 'id' },
              successMex: 'Salvataggio eseguito con successo',
              sendFullObject: true
            },
            {
              nome: 'Salva',
              close: true,
              class: ' btn ',
              labelClass: 'ml-1 ',
              type: 'POST',
              restRoute: '/anagrafica/persone/add',
              icon: 'far fa-save text-success',
              placeholder: 'Salva',
              hideif: { fieldexist: 'id' },
              successMex: 'Salvataggio eseguito con successo',
              sendFullObject: true
            }
          ],
          sezioni: [
            {
              sezione: "Anagrafica",
              titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
              campi: [
                {
                  nome: "Nome *",
                  oggetti: ["nome"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3"
                },
                {
                  nome: "Cognome *",
                  oggetti: ["cognome"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3"
                },
                {
                  nome: "Data Nascita",
                  field: ["dataNascita"],
                  oggetti: ["infoAgg"],
                  modificabile: true,
                  inputType: "date",
                  type: "object",
                  class: "col-lg-3"
                },
                {
                  nome: "CF",
                  oggetti: ["codice_fiscale"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3"
                },
                {
                  nome: "Titolo di studio",
                  field: ["titoloStudio"],
                  oggetti: ["infoAgg"],
                  modificabile: true,
                  inputType: "text",
                  type: "object",
                  class: "col-lg-3"
                },
                {
                  nome: "IBAN",
                  field: ["iban"],
                  oggetti: ["infoAgg"],
                  modificabile: true,
                  inputType: "text",
                  type: "object",
                  class: "col-lg-3"
                },
                {
                  nome: "Note",
                  field: ["note"],
                  oggetti: ["infoAgg"],
                  modificabile: true,
                  inputType: "text",
                  type: "object",
                  class: "col-lg-3"
                },
                {
                  nome: "Ordine",
                  oggetti: ["ordine"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                }
              ]
            },
            {
              sezione: "Recapito",
              titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
              campi: [
                {
                  nome: "Indirizzo",
                  oggetti: ["indirizzo"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3",
                },
                {
                  nome: "CAP",
                  oggetti: ["cap"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3",

                },
                {
                  nome: "Città",
                  oggetti: ["citta"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3",

                },
                {
                  nome: "Telefono",
                  oggetti: ["telefono"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3",
                },
                {
                  nome: "Cellulare",
                  oggetti: ["cellulare"],
                  modificabile: true,
                  inputType: "text",
                  class: "col-lg-3",
                },
                {
                  nome: "Email *",
                  oggetti: ["email"],
                  modificabile: true,
                  inputType: "email",
                  class: "col-lg-3",

                }
              ]
            },
            {
              sezione: "Contratto",
              titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
              campi: [
                {
                  nome: "Data Assunzione",
                  oggetti: ["dataAssunzione"],
                  modificabile: true,
                  inputType: "date",
                  class: "col-lg-3",
                },
                {
                  nome: "Ora Entrata",
                  oggetti: ["oraEntrata"],
                  modificabile: true,
                  inputType: "time",
                  class: "col-lg-3",
                },
                {
                  nome: "Ora Uscita",
                  oggetti: ["oraUscita"],
                  modificabile: true,
                  inputType: "time",
                  class: "col-lg-3"
                },
                {
                  nome: "Pausa (min)",
                  oggetti: ["pausa"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "Ferie/mese",
                  oggetti: ["ferie"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "ROL/mese",
                  oggetti: ["rol"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "Legge 104/mese",
                  oggetti: ["legge104"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "ExFestività/anno",
                  oggetti: ["exFestivita"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "Ferie residue",
                  oggetti: ["ferieGodute"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "ROL residue",
                  oggetti: ["rolGodute"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "Legge 104 residue",
                  oggetti: ["legge104Godute"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
                {
                  nome: "ExFestività residue",
                  oggetti: ["exFestivitaGodute"],
                  modificabile: true,
                  inputType: "number",
                  class: "col-lg-3"
                },
              ]
            },
            {
              sezione: 'Account',
              titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
              campi: [
                {
                  nome: "Nome Utente",
                  oggetti: ["username"],
                  modificabile: true,
                  requiredif: {
                    func: (x) => { return !(x.password || x.ruoliAccesso)}
                  },
                  inputType: "text",
                  class: "col-lg-3"
                },
                {
                  nome: "Password",
                  oggetti: ["password"],
                  modificabile: true,
                  requiredif: { fieldexist: ['confPassword'] },
                  inputType: "password",
                  class: "col-lg-3"
                },
                {
                  nome: "Conferma Password",
                  oggetti: ["confPassword"],
                  modificabile: true,
                  requiredif: { fieldexist: ['confPassword'] },
                  inputType: "password",
                  class: "col-lg-3"
                },
                {
                  nome: 'Tipo di Accesso',
                  source: '/anagrafica/ruoli/list',
                  responseHasData: true,
                  parameter: [],
                  oggetti: ['ruoliAccesso'],
                  requiredif: { fieldexist: ['password', 'ruoliAccesso'] },
                  internalOutput: 'ruoliAccessoObject',
                  OutputField: 'ruoliAccesso',
                  OnChange: 'OnruoliAccessoChange',
                  modificabile: true,
                  inputType: 'singleDropdown',
                  placeholder: 'Seleziona',
                  settings: {
                    singleSelection: false,
                    closeDropDownOnSelection: true,
                    singleOutput: false,
                    idField: 'id',
                    textField: 'ruolo',
                    searchPlaceholderText: "Cerca",
                    allowSearchFilter: true,
                    allowRemoteDataSearch: false,
                  },
                  class: 'col-lg-3',
                  visibleifProhibited: true
                }
              ]
            }
          ]
        },
        { id: 'files', tipo: 'template', titolo: 'Files', component: 'Files', hideif: { fieldnotexist: 'id' } }
      ]
    },
    ProdottiAddOn: {
      taglie: true,
    },
    DashboardAddon: [
      {
        url: '/progetti/progetti/dashboard',
        initObj: [
          { campo: 'anno', value: AnnoCorrente() },
          { campo: 'trimestre', value: 'A' },
        ],
        filters: [
          { nome: 'Anno:', oggetti: ['anno'], modificabile: true, inputType: 'numeric', class: 'col-lg-3', OnChange: 'refresh' },
          {
            nome: "Periodo",
            source: [{ id: 'A', label: 'Anno intero' }, { id: "1", label: "Primo Trimestre" }, { id: "2", label: "Secondo Trimestre" }, { id: "3", label: "Terzo Trimestre" }, { id: "4", label: "Quarto Trimestre" }],
            oggetti: ['cSomministrazioni'],
            internalOutput: 'trimestreObject',
            OutputField: 'trimestre',
            modificabile: true,
            OnChange: 'refresh',
            inputType: 'singleDropdown',
            placeholder: "Seleziona",
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'label',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
        ],
        campi: [
          { nome: "Ordini di Acquisto ", tipo: "text", oggetto: "ordini_acquisto_tot", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Ordini conto terzi", tipo: "text", oggetto: "ordini_produzione_tot", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Ordini di Lavorazione", tipo: "text", oggetto: "ordini_lavorazione_tot", class: 'bg-info', larghezza: 'col-lg-3' },
          { nome: "Ordini Interni", tipo: "text", oggetto: "ordini_interni_tot", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Ordini di Acquisto ", tipo: "text", oggetto: "ordini_acquisto_num", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Ordini conto terzi", tipo: "text", oggetto: "ordini_produzione_num", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Ordini di Lavorazione", tipo: "text", oggetto: "ordini_lavorazione_num", class: 'bg-info', larghezza: 'col-lg-3' },
          { nome: "Ordini Interni", tipo: "text", oggetto: "ordini_interni_num", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Prodotti Acquistati", tipo: "text", oggetto: "ordini_acquisto_prod", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Prodotti conto terzi", tipo: "text", oggetto: "ordini_produzione_prod", larghezza: 'col-lg-3', class: 'bg-info' },
          { nome: "Prodotti Lavorati", tipo: "text", oggetto: "ordini_lavorazione_prod", class: 'bg-info', larghezza: 'col-lg-3' },
          { nome: "Prodotti Immagazzinati", tipo: "text", oggetto: "ordini_interni_prod", larghezza: 'col-lg-3', class: 'bg-info' },
          {
            dataFunc: (x) => {
              return [
                { label: 'Ordini di Acquisto', value: x.numero_acquisto },
                { label: 'Ordini conto terzi', value: x.numero_produzione },
                { label: 'Ordini di Lavorazione', value: x.numero_lavorazione },
                { label: 'Ordini Interni', value: x.numero_interni },
                { label: 'Ordini', value: x.numero_tot },
              ]
            },
            nome: "Numero Prodotti per Ordine", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
              responsive: true,
              lineTension: 0,
              hideTutti: true,
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                  },
                },
              },
            }
          },
          {
            dataFunc: (x) => {
              return [
                { label: 'Ordini di Acquisto', value: x.fatturato_acquisto },
                { label: 'Ordini conto terzi', value: x.fatturato_produzione },
                { label: 'Ordini di Lavorazione', value: x.fatturato_lavorazione },
                { label: 'Ordini Interni', value: x.fatturato_interni },
                { label: 'Ordini', value: x.fatturato_tot },
              ]
            },
            nome: "Fatturato per Ordine", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
              responsive: true,
              lineTension: 0,
              hideTutti: true,
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                  },
                },
              },
            }
          },

        ]
      }
    ],
    Modules: { Dashboard: true },
    ProgettiAddOn: {
      CampiOfferta: [
        {
          nome: "Offerta.Responsabile",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "cliente.commerciale",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        },
        {
          nome: "cliente.segnalatore",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        },
        {
          nome: "Colore",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Lavorato",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        },
        {
          nome: "Offerta.Conferma",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Offerta.Ordine",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Offerta.Offerta",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Offerta.Accettazione",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Completato:",
          hideif: { hasCapacity: ['is-cliente-ordine'] }
        },
        {
          nome: "Annullato:",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        },
        {
          nome: "Data Annullamento:",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        },
        {
          nome: "Note Private",
          hideif: { fieldexist: 'id', fieldnotexist: 'id' }
        }
      ],
    }
  }, env)
  env = addModule(CrmEnv(), env)
  return env;
}

var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());
  return env;
}

export var environment: any = FullEnv();

